import React from 'react';
import { NavHashLink as NavLink } from 'react-router-hash-link';
import './whatWeDo.css';

const whatWeDo = () => {
  return (
    <div className="wwd_wrpr" id="services">
      <p className="bf hdr">What We Do</p>
      <div className="df secs_wrpr">
        <div className="df sec ux">
          <div className="icon_wrpr" />
          <div className="inner_hdr uc bf">UX - UI + Web design</div>
          <p className="blf txt">
            We believe no business is the same, therefor we design and develop
            fully custom tailored websites for your specific needs, our UX-UI
            specialist design interfaces in a more useful manner with all the
            qualities like ease of use and effectiveness.
          </p>
          <div className="df arrow" />
        </div>
        <div className="df sec csft">
          <div className="icon_wrpr" />
          <div className="inner_hdr uc bf">Custom software</div>
          <p className="blf txt">
            We are obsessed with attractive enterprise software design, we
            create visual experiences that offer great user experience. From
            wireframes to complete designed user flowes, we thrive for
            perfection at every stage.
          </p>
          <div className="df arrow" />
        </div>
        <div className="df sec mbl_app">
          <div className="icon_wrpr" />
          <div className="inner_hdr uc bf">Mobile app design</div>
          <p className="blf txt">
            Be it a simple phone app, a custom saas app or an Android wearable,
            we have left no stone unturned, coding is our passion and with our
            expert design team we give only the best we will design and develop
            your app idea to perfection.
          </p>
          <div className="df arrow" />
        </div>
        <div className="df sec b_and_m">
          <div className="icon_wrpr" />
          <div className="inner_hdr uc bf">Branding &amp; marketing</div>
          <p className="blf txt">
            Our award winning design team masterfully creates brand assets that
            inspire emotion and drive results. From crafting your logo to
            designing your branding and print materials, our talented designers
            have you covered.
          </p>
          <div className="df arrow" />
        </div>
      </div>

      {/* <button className="lm_btn blf">Learn more</button> */}

      <NavLink className="lm_btn blf" smooth to="/#contact">
        Learn more
      </NavLink>
    </div>
  );
};

export default whatWeDo;



// WEBPACK FOOTER //
// ./src/components/what-we-do/whatWeDo.js